import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CollabPullDialogModule } from '@portal-core/collab/components/collab-pull-dialog/collab-pull-dialog.module';
import { WorkspacePullChangesBarComponent } from './workspace-pull-changes-bar.component';

@NgModule({
  declarations: [WorkspacePullChangesBarComponent],
  imports: [
    CollabPullDialogModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule
  ],
  exports: [
    WorkspacePullChangesBarComponent
  ]
})
export class WorkspacePullChangesBarModule { }
